import './great-diving.sass'

export default function GreatDiving({ title, bulletPoints, className }) {
  if(!bulletPoints.length) {
    return ''
  }
  return <div className={`collections__section great-diving ${className}`}>
    <h2 className='collections__section__title'>{ title }</h2>

    <div className='collections__section__content'>
      <ul className='bullet-points'>
        {
          bulletPoints.map(function(point) {
            return <li key={point}>
              <span className='blue-point'>
                <i className='font-icons icon-tick' />
              </span>
              <span className='bullet-points__text'>{ point }</span>
            </li>
          })
        }
      </ul>
    </div>
  </div>
}
